import React from 'react';
import Container from 'react-bootstrap/Container';

import RuleGenerator from './components/RuleGenerator';
import './bootstrap.min.css';
import './App.css';

function App() {
  return (
    <Container className="App">
      <header className="App-header">
        <h1>IPTables Guru</h1>
        <div>A quick and simple IPTables rule generator.</div>
      </header>
      <main className="App-main">
        <RuleGenerator/>
      </main>
      <footer className="App-footer">
        &copy; 2020 pspaul
      </footer> 
    </Container>
  );
}

export default App;
